import { Switch } from "../../primitive/switch";

import { Label } from "../label";
import { getFieldError } from "./get-field-error";
import { useFieldContext } from "./form";

interface FormSwitchProps extends Omit<
  React.ComponentProps<typeof Switch>,
  "checked" | "onCheckedChange"
> {
  label?: string;
  showErrorMessage?: boolean;
}

function FormSwitch({
  label,
  showErrorMessage = true,
  ...props
}: FormSwitchProps) {
  const field = useFieldContext<boolean>();

  return (
    <div className="flex flex-col gap-2">
      <div className="flex items-center gap-2">
        <Switch
          id={field.name}
          checked={field.state.value ?? false}
          onCheckedChange={(checked) => field.handleChange(checked)}
          {...props}
        />
        {label ? (
          <Label htmlFor={field.name} className="cursor-pointer">
            {label}
          </Label>
        ) : null}
      </div>
      {showErrorMessage && field.state.meta.errors.length > 0 ? (
        <span className="text-sm text-destructive">
          {getFieldError(field.state.meta.errors[0])}
        </span>
      ) : null}
    </div>
  );
}

export { FormSwitch };
